<template>
  <van-config-provider class="van-safe-area-bottom" :theme="theme">
    <router-view v-slot="{ Component }" :key="currentRoute.meta?.appRouterViewId ?? 'app'">
      <keep-alive :include="keepAliveRoutes" :exclude="excludeRoutes">
        <component :is="Component" :key="undefined" />
      </keep-alive>
    </router-view>
  </van-config-provider>
</template>

<script setup lang="ts">
import { useTitle } from '@/hooks/useTitle';
import type { ConfigProviderTheme } from 'vant';
import { projectStorage } from '@tencent/fd-utils';
import { useAppStore } from '@/store/modules/app';
import { useConfigStore } from '@/store/modules/config';
import { keepAliveRoutes, excludeRoutes, addRouteToExclude, recoverKeepAlive } from '@/router/routes';
import { useRouter } from 'vue-router';
import { ReqAreaCode } from '@tencent/fd-types';
import { router } from '@/router';

const { currentRoute } = useRouter();

const appStore = useAppStore();
const configStore = useConfigStore();
// const userStore = useUserStore();

// 自动设置页面标题
useTitle();

function init() {
  // 如果出现关键接口错误 or 没登录，后续逻辑不再执行
  const isAuth = projectStorage.get('isAuth');
  if (!isAuth) {
    router.push('/error');
    return;
  }
  // 三级行政区数据
  // 将默认的区参数抽离到字典接口
  const level = configStore.dynamicConfig?.feSysConfig.areaLevel || 3;
  const areaCode = configStore.dynamicConfig?.feSysConfig.areaRange || ['440306000000'];
  const req: ReqAreaCode = {
    areaCode, // : ['440306000000'], // 宝安区
    level, // : 3,
  };
  configStore.fetchAreaCode(req);
  // 拉取地埋位置授权
  // console.log('xxx-location-start');
  appStore.getLocation();
  // console.log('xxx-location-end');
}

init();

const theme = ref<ConfigProviderTheme>('light');
// const themeConfigVars = ref(themeConfig);
const themeMode = computed(() => appStore.theme);

watch(
  themeMode,
  (val) => {
    if (val === 'dark' || projectStorage.get('theme') === 'dark') {
      theme.value = 'dark';
      document.querySelector('html')?.setAttribute('data-theme', 'dark');
    } else {
      theme.value = 'light';
      document.querySelector('html')?.setAttribute('data-theme', 'light');
    }
  },
  { immediate: true },
);

// import { onBeforeRouteLeave } from 'vue-router';
// onBeforeRouteLeave((to) => {
//   console.log('xxx-sign', to.name);
//   if (!['agreement-page'].includes(String(to.name))) {
//     addRouteToExclude(String(to.name));
//   } else {
//     recoverKeepAlive(String(to.name));
//   }
// });
</script>

<style lang="less" scoped>
.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: -176px;
  z-index: 0;
  height: 440px;

  // background: linear-gradient(180deg, #dfecfc 60.04%, #f2f5fa 94.74%, #f4f6fa 94.74%);
  background: linear-gradient(180deg, #e0edfc 0%, rgba(255, 255, 255, 0%) 100%);
}
</style>
